

import { defineComponent} from 'vue'
import {Service} from '@/components/molecules'

export default defineComponent({
  components: {Service}
})
